import type { ReportButtonLabels } from '../../report-button-content';

export const reportButton: ReportButtonLabels = {
  report: 'Dèan aithris air an duilleag seo',
  title: 'Dèan aithris air duilgheadas leis an duilleag seo',
  reasons: {
    'inaccurate-or-fabricated': 'Fiosrachadh mearachdach no meallta',
    'wrong-product': 'Chan eil am bathar a\' freagairt ris an duilleag',
    'sexually-explicit': 'Susbaint fheiseil fhollaiseach',
    'regulated-product': 'Bathar le òrdugh-leigheis no fo riaghladh',
    'dangerous-product': 'Bathar cunnartach',
    'ip-infringement': 'A\' briseadh mo chòraichean (comharra-malairt/còir-lethbhreac)',
    other: 'Rud eile',
  },
  detail: 'Mion-fhiosrachadh (roghainneil)',
  submit: 'Cuir an aithris',
  cancel: 'Sguir dheth',
  sent: 'Tapadh leat. Bidh sinn a\' sgrùdadh aithrisean taobh a-staigh 24 uair a thìde.',
  failed: 'Cha b\' urrainn dhuinn an aithris a chur. Feuch a-rithist.',
};
